import { useLocation } from '@reach/router';
import React, { useEffect } from 'react';
import useModalStore from '../../store/useModalStore';
import Confirmation from '../forms/confirmation';
import { Close } from '../svg/close';
import Modal from './modal';

const ConfirmModal = () => {
  const { isClosable, closeModal, openModal, opened, setModalType } =
    useModalStore();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('registration') === 'true') {
      openModal();
    }
  }, [location.search, openModal]);

  const handleOnClose = () => {
    isClosable && closeModal();
    setModalType('login');
  };

  return (
    <Modal open={opened} onClose={handleOnClose}>
      <Close
        className="relative z-50 left-[14rem] top-[-13.5rem]"
        onClick={handleOnClose}
      />
      <Confirmation />
    </Modal>
  );
};

export default ConfirmModal;
